export default {
  minivariant: false
};
